module.exports = __webpack_public_path__ + "static/img/20230316_03.6def57f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2023/20230316_03.png
// module id = O5d2
// module chunks = 0